let rsapublic = '-----BEGIN PUBLIC KEY-----\n' +
'MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgGq+E9sHEhyOdz8l7A0C2ngtPyX+\n' +
'UVvRepUdmEp4pZpnnQTwmU5euNKNhzqSJW52pQEHNuLsr07i8BUQTGff8HtVngAr\n' +
'RcsYIAwoAr5v4rL2gHbq0Y2Oz0+FNm+tOkxIj+yhpuFQOfUszG2kwQfys8LBFd/t\n' +
'1FkAF4iS8EuZJxU3AgMBAAE=\n' +
'-----END PUBLIC KEY-----'

export default rsapublic
